import React, {FC} from 'react';

interface Props extends React.HTMLProps<HTMLDivElement> {
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
}

export const Container: FC<Props> = props => {
  return (
    <div
      {...props}
      className={`w-full max-w-${props.maxWidth || 'xl'} mx-auto ${
        props.className
      }`}
    >
      {props.children}
    </div>
  );
};
